import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/external-campaign-metrics`

/**
 * External campaign metrics upload
 */
export const externalCampaignMetricsKey = 'externalCampaignMetrics'

export const ExternalCampaignMetricsService = {
  upload: ({
    body,
    axiosOptions = {}
  }: {
    body: FormData
    axiosOptions?: Record<string, unknown>
  }) => axios.post(`${baseURL}/upload`, body, axiosOptions),
  list: (params?: { page?: number; quantity?: number }) =>
    axios.get(`${baseURL}/`, { params }),
  exportMetrics: (params: {
    start_date: string
    end_date: string
    channel?: string
    placement_name?: string
  }) =>
    axios.get(`${baseURL}/export`, {
      params,
      responseType: 'blob'
    })
}
